export type WelcomeEmailKind = "school" | "district";

export type WelcomeEmailTarget = {
  kind: WelcomeEmailKind;
  id: number;
};

export type WelcomeEmailAccount = WelcomeEmailTarget & {
  name: string;
  subdomain: string;
  username: string;
  contactName: string;
  contactEmail: string;
};

/** Path for the school or district welcome-email route. The id is in the path. */
export function welcomeEmailPath(target: WelcomeEmailTarget): string {
  if (target.kind === "school") {
    return `/schools/${target.id}/welcome-email`;
  }
  return `/districts/${target.id}/welcome-email`;
}
